import * as constants from "../constants.js";
import notifications from "../notifications";


export default {
    OnSuccess(description) {
        notifications.Success("Utilizador", description);
    },

    OnWarning(resp, description) {
        notifications.Warning("Utilizador", description);
        console.log(resp);
    },

    OnError(resp, description) {
        notifications.Error("Utilizador", description);
        console.log(resp);
    },

    OnUnauthorized(){
        window.location.reload();
    },
    
    UpdateUser: async function (user, isFirstTime) {
        let reqUriParams = ``;
        if (isFirstTime) {
            reqUriParams += `&isFirstTime=${isFirstTime}`;
        }

        return await fetch(
                `${constants.API_ENDPOINT_USER}?${reqUriParams}`, 
                {
                    method: constants.HTTP_METHOD_PUT,
                    headers: constants.HTTP_HEADERS_JSON,
                    body: JSON.stringify(user)
                }
            ).then(
                resp => 
                {
                    if (!resp.ok) {
                        if (resp.status >= 500) {
                            this.OnError(resp, "Ocorreu uma anomalia ao atualizar o utilizador");
                            return null;
                        }
                        if(resp.status == 401) {
                            this.OnUnauthorized();
                            return null;
                        }
                    }
                    return resp.json();
                }
            )
            .then(
                function(data) { // "data" is the parsed version of the JSON returned from the above endpoint.
                    if(!is_empty(data) && data.Errors != null && !is_empty(data.Errors)) {
                        let message = data.Errors.map(r => $('#' + r.Field).parents().children('label')[0].innerText + ' é ' + r.Message + '\n');
                        notifications.Warning("Utilizador", "Verifique o(s) campo(s) assinalado(s) com erro: " + message);
                    }
                    return data;
                }
            );
    },
    SetFavorite: async function (idPub) {
        return await fetch(constants.API_ENDPOINT_USER_FAVORITE + "/" + idPub, {
            method: constants.HTTP_METHOD_POST
        }).then(resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    this.OnError(resp, "Ocorreu uma anomalia ao salvar ou remover o favorito");
                    return null;
                }
                return { OK: false, StatusCode: resp.status };
            }else{
                return { OK: true }
            }
        });

    },
    FavoriteCount: async function () {
        return await fetch(constants.API_ENDPOINT_USER_FAVORITE + "/count", {
            method: constants.HTTP_METHOD_POST
        }).then(resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    this.OnError(resp, "Ocorreu uma anomalia a consultar o número de favoritos");
                    return null;
                }
                return { OK: false, StatusCode: resp.status };
            }else{
                return resp.text();
            }
        });

    },

}